import { render } from "./Setup.vue?vue&type=template&id=3f94c81c"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"
script.render = render

export default script